// extracted by mini-css-extract-plugin
module.exports = {"title-divider":"TitleDivider_title-divider__MGOqh","subtitle":"TitleDivider_subtitle___gqC_"};